import React, { useRef, useCallback } from 'react';
import DropDownButton from 'devextreme-react/drop-down-button';
import { Template } from 'devextreme-react/core/template';
import { UserMenuSection } from '../user-menu-section/UserMenuSection';
import type { UserPanelProps } from '../../../types';
import type { UserState } from '../../../types/types.user';
import { useAppSelector } from '../../../contexts/hooks';
import List from 'devextreme-react/list';
import './UserPanel.scss';
import DefaultAvantar from '../../../images/defaulAvatar.png'

export const UserPanel = ({ menuMode }: UserPanelProps) => {
  const UsInf = useAppSelector((user) => user.userInfo) as UserState;
  const listRef = useRef<List>(null);

  const dropDownButtonAttributes = {
    class: 'user-button',
  };

  const buttonDropDownOptions = {
    width: 250,
    hideOnOutsideClick: true,
  };

  const dropDownButtonContentReady = useCallback(
    ({ component }) => {
      component.registerKeyHandler('downArrow', () => {
        listRef.current?.instance.focus();
      });
    },
    [listRef]
  );

  return (
    <div className='user-panel'>
      {menuMode === 'context' && (
        <DropDownButton stylingMode='text' icon={UsInf?.User?.Us_Foto || DefaultAvantar} showArrowIcon={false} elementAttr={dropDownButtonAttributes} dropDownOptions={buttonDropDownOptions} dropDownContentTemplate='dropDownTemplate' onContentReady={dropDownButtonContentReady}>
          <Template name='dropDownTemplate'>
            <UserMenuSection listRef={listRef} showAvatar={true} />
          </Template>
        </DropDownButton>
      )}
      {menuMode === 'list' && <UserMenuSection showAvatar />}
    </div>
  );
};
